/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';

import ErrorSvg from '../../assets/error.svg';
import Icon from '../../../../molecules/Icon';

import {
  Astericks,
  Container,
  ErrorIcon,
  ErrorMessage,
  Label,
  LabelContainer,
  Select,
  SelectWrapper,
  Tooltip,
  TooltipContainer,
  Wrapper,
} from '../styles/FormSelect.styled';

const FormSelect = ({
  id,
  type,
  name,
  label,
  placeholder,
  autoComplete,
  required,
  errorMessage,
  value,
  options,
  handleChange,
  hidden,
  layout,
  styles,
  helperText,
}) => {
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return (
    <Container
      className={`custom-form-control control-${name}`}
      hidden={hidden}
      styles={styles}
    >
      <Wrapper className="custom-form-control-wrapper" layout={layout}>
        <LabelContainer>
          <Label htmlFor={name} className="custom-form-control-label">
            {label}
            {required && <Astericks>*</Astericks>}
          </Label>
          <TooltipContainer
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
          >
            <Icon id="info-circle" width="18px" height="18px" />
            <Tooltip className={tooltipVisible ? 'visible' : 'hidden'}>
              {helperText}
            </Tooltip>
          </TooltipContainer>
        </LabelContainer>
        <SelectWrapper>
          <Select
            id={id}
            type={type}
            name={name}
            placeholder={placeholder}
            autoComplete={autoComplete}
            value={value}
            className={errorMessage ? 'error' : ''}
            onChange={e => handleChange(e)}
          >
            {options?.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </SelectWrapper>
        {errorMessage && type !== 'checkbox' && (
          <ErrorIcon className="error-icon" src={ErrorSvg} alt="Error Icon" />
        )}
      </Wrapper>
      {errorMessage && (
        <ErrorMessage
          className="error-message"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      )}
    </Container>
  );
};

export default FormSelect;
